import React, { ForwardedRef, forwardRef } from 'react';

const CartIcon = forwardRef(
  (props: React.SVGProps<SVGSVGElement>, ref: ForwardedRef<SVGSVGElement>) => {
    return (
      <svg
        ref={ref}
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        width="48"
        height="48"
        version="1.1"
        viewBox="0 0 300 300"
        xmlSpace="preserve"
        {...props}
      >
        <path
          d="M232.7 252.1L105.2 252.1 59.6 90.7 32.1 90.7 32.1 78.4 68.9 78.4 114.6 239.7 232.7 239.7z"
          fill="currentColor"
        ></path>
        <path
          d="M232.7 224.7L102.2 224.7 102.2 212.4 223.7 212.4 251.1 126.4 95.8 121.2 96.2 108.8 267.9 114.6z"
          fill="currentColor"
        ></path>
        <path
          d="M110.9 288c-13.3 0-24.1-10.8-24.1-24.1s10.8-24.1 24.1-24.1 24.1 10.8 24.1 24.1c0 13.2-10.8 24.1-24.1 24.1zm0-35.9c-6.5 0-11.8 5.3-11.8 11.8s5.3 11.8 11.8 11.8c6.5 0 11.8-5.3 11.8-11.8s-5.4-11.8-11.8-11.8zM232.7 288c-13.3 0-24.1-10.8-24.1-24.1s10.8-24.1 24.1-24.1 24.1 10.8 24.1 24.1c0 13.2-10.8 24.1-24.1 24.1zm0-35.9c-6.5 0-11.8 5.3-11.8 11.8s5.3 11.8 11.8 11.8 11.8-5.3 11.8-11.8-5.3-11.8-11.8-11.8z"
          fill="currentColor"
        ></path>
        <path
          d="M132.8 115.8H145.20000000000002V218.89999999999998H132.8z"
          fill="currentColor"
          transform="rotate(-7.022 138.99 167.404)"
        ></path>
        <path
          d="M143 162.3H243.7V174.70000000000002H143z"
          fill="currentColor"
          transform="rotate(-83.984 193.292 168.49)"
        ></path>
        <path
          d="M88 162.3H244.2V174.70000000000002H88z"
          fill="currentColor"
        ></path>
        <path d="M243.7 36.8L243.7 36.7 256 35.3z" fill="currentColor"></path>
        <path
          d="M232.1 110.8l-11.6-4.2c1.2-3.4 2.4-6.6 3.8-10.1 1.3-3.3 2.6-6.9 4.2-11.3l.5-1.1c.7-1.9 1.4-3.9 2.1-5.8 1.1-3.1 2.2-6.1 3.2-8.9l5.9 1.7 5.8 2.1c-1.1 3.1-2.2 6.2-3.4 9.3-.8 2.2-1.6 4.5-2.5 6.7l-1.4 3.6c-1.1 2.9-2.1 5.5-3 7.9-1.2 3.6-2.4 6.7-3.6 10.1zM178.5 118.9l-11.5-4.6c9.5-23.8 18.4-48.4 26.3-70.1l.3-.7c.8-2.2 1.6-4.5 2.6-6.7l11.3 4.9c-.8 1.9-1.6 3.9-2.3 5.9l-.3.7c-7.9 21.9-16.8 46.7-26.4 70.6z"
          fill="currentColor"
        ></path>
        <path
          d="M235.5 71.2c-6.4 0-14.2-2.3-20.5-10.1l9.6-7.8c6.8 8.5 15.3 4.9 15.6 4.7l5 11.3c-2.3 1-5.8 1.9-9.7 1.9zM227.1 94.8c-6.4 0-14.2-2.3-20.5-10.1l9.6-7.8c6.6 8.1 14.8 5.1 15.7 4.7l4.9 11.3c-2.3 1-5.7 1.9-9.7 1.9z"
          fill="currentColor"
        ></path>
        <path
          d="M246 73.2L234.1 69.9 244.5 32.1 235.6 25.6 217.8 30.6 205.6 44.7 196.2 36.6 210.9 19.7 238.1 12 258.7 27.2z"
          fill="currentColor"
        ></path>
      </svg>
    );
  },
);

CartIcon.displayName = 'CartIcon';

export default CartIcon;
